//Any other keycode can be found here: https://keycode.info/

export enum keyCodes {
  esc = "Escape",
  enter = "Enter",
  arrDown = "ArrowDown",
  arrUp = "ArrowUp",
  tab = "Tab"
}
